package dev.kotlinfest._2026.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initChildcarePage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("Childcare.md", FrontMatterElement.Builder { addScalar("title", "託児サービスのご案内"); addScalar("description", "Kotlin Fest 2026では、0歳6ヶ月～小学6年生のお子様を対象に、無料の託児サービスを実施します。申し込み期限は2026年11月6日（金）17:00、または定員に達し次第終了です。"); }))
}

@Page("/childcare")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun ChildcarePage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("託児サービスの概要") }) {
        org.jetbrains.compose.web.dom.Text("託児サービスの概要")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("本イベントでは、")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("0歳6ヶ月～小学6年生")
        }
        org.jetbrains.compose.web.dom.Text("のお子様を対象に託児サービスを実施します。当日の保育スタッフは、保育の有資格者が対応いたします。")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("託児時間：")
            }
            org.jetbrains.compose.web.dom.Text(" 10:30～最大18:50まで（昼食時間帯の12:15～13:00は一度クローズします。）")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("託児会場：")
            }
            org.jetbrains.compose.web.dom.Text(" イベント会場と同じ建物内で実施予定です。詳細の場所は、お申し込み者にお伝えします。")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("定員：")
            }
            org.jetbrains.compose.web.dom.Text(" 5名（お子様の年齢構成により、定員が前後する場合があります。）")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("対象年齢：")
            }
            org.jetbrains.compose.web.dom.Text(" 0歳6ヶ月～小学6年生")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("託児料金：")
            }
            org.jetbrains.compose.web.dom.Text(" 無料")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("お申し込み") }) {
        org.jetbrains.compose.web.dom.Text("お申し込み")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("申し込み期限：2026年11月6日（金）17:00、または定員に達し次第終了")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("託児をお申し込みの方は、チケット申し込み時に「託児所の利用を希望しますか？」で ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("「はい」")
        }
        org.jetbrains.compose.web.dom.Text(" を選択してください。メールにてご案内いたします。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("キャンセル待ちもお受けします。満席や締め切り後は、キャンセル待ちにご登録ください。キャンセルが出た場合には、随時ご連絡をさせていただきます。")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("保育担当事業者") }) {
        org.jetbrains.compose.web.dom.Text("保育担当事業者")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("東京都認可外保育施設居宅訪問型（事業者）登録済み事業者")
        org.jetbrains.compose.web.dom.Br()
        com.varabyte.kobweb.silk.components.navigation.Link("https://childcarecollaboration.com/") {
            org.jetbrains.compose.web.dom.Text("合同会社Child Care Collaboration")
        }
    }
}
